import tools from 'altrac-conversions';

export function statusMoistureSensor(status, device) {
  const reading0 = device.reading0 || {};
  const physical = device.physical || {};

  const inputPower = reading0['186'] & 0x4;
  if (inputPower) {
    status.other.push({
      id: 'moistureSensorPowerOn',
      rank: 100,
      code: 'normal',
      category: 'power',
      shortMessage: 'MoistureSensor Device has power',
      message: `MoistureSensor Device ${device.physical.deviceNumber} has power.`,
    });
  } else {
    status.other.push({
      id: 'moistureSensorPowerOff',
      rank: 15,
      code: 'disconnected',
      category: 'power',
      shortMessage: 'MoistureSensor Device does not have power',
      message: `MoistureSensor Device ${device.physical.deviceNumber} does not have power.`,
    });
    status.deviceHeadlineDanger.enabled = true;
    status.deviceHeadlineDanger.text.push('Altrac is not receiving power');
  }

  const moistureLevel = tools.displayFormula(
    'moistureSensor',
    100,
    0,
    null,
    '1',
    reading0,
    null,
    physical,
  );

  if (moistureLevel === 'NOT\nSET') {
    status.other.push({
      id: 'moistureSensorNoThresholdSettings',
      rank: 1,
      code: 'disconnected',
      category: 'moisture',
      shortMessage: 'Moisture Sensor Thresholds Not Set',
      message: `Moisture Sensor ${device.physical.deviceNumber} thresholds not set.`,
    });
  } else if (moistureLevel === 'ERR') {
    status.other.push({
      id: 'moistureSensorLevelError',
      rank: 1,
      code: 'danger',
      category: 'moisture',
      shortMessage: 'Bad data received from moisture probe. Please check probe installation.',
      message: `Moisture Sensor ${device.physical.deviceNumber} level sensor bad data.`,
    });
    status.deviceHeadlineDanger.enabled = true;
    status.deviceHeadlineDanger.text.push('Bad data received from moisture probe. Please check probe installation.');
  } else if (moistureLevel === 'NC') {
    status.other.push({
      id: 'moistureSensorConnectionError',
      rank: 1,
      code: 'danger',
      category: 'moisture',
      shortMessage: 'No data received from moisture probe. Please check probe wiring.',
      message: `Moisture Sensor ${device.physical.deviceNumber} level sensor bad data.`,
    });
    status.deviceHeadlineDanger.enabled = true;
    status.deviceHeadlineDanger.text.push('No data received from moisture probe. Please check probe wiring.');
  } else if (moistureLevel >= 100) {
    status.other.push({
      id: 'moistureSensorLevelWet',
      rank: 1,
      code: 'info',
      category: 'moisture',
      shortMessage: 'Moisture Sensor Above Max Threshold',
      message: `Moisture Sensor ${device.physical.deviceNumber} is above max moisture threshold.`,
    });
  } else if (moistureLevel <= 0) {
    status.other.push({
      id: 'moistureSensorLevelDry',
      rank: 1,
      code: 'warning',
      category: 'moisture',
      shortMessage: 'Moisture Sensor Below Min Threshold',
      message: `Moisture Sensor ${device.physical.deviceNumber} is below min moisture threshold.`,
    });
  } else if (moistureLevel > 0 && moistureLevel < 100) {
    status.other.push({
      id: 'moistureSensorLevelBetween',
      rank: 20,
      code: 'normal',
      category: 'moisture',
      shortMessage: 'Moisture Sensor Between Thresholds',
      message: `Moisture Sensor ${device.physical.deviceNumber} is between moisture thresholds.`,
    });
  } else {
    status.other.push({
      id: 'moistureSensorLevelUnknown',
      rank: 100,
      code: 'normal',
      category: 'moisture',
      shortMessage: 'Moisture Sensor Value Unknown',
      message: 'Moisture Sensor Value Unknown.',
    });
  }
}
